import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, CouponRemoveSlice } from './types'
import { setCart } from '../cart'
import { PWAThunk } from 'lib/core/data'
import { Callback } from 'lib/types'

export const initialState: Slice = {}

interface ActionData {
  cartId: string
}

const getSlice = (slice: CouponRemoveSlice): CouponRemoveSlice => {
  return slice ?? ({
    isFetching: false,
    isSuccess: false,
    isFailure: false
  })
}

const slice = createSlice({
  name: 'quote/couponRemove',
  initialState,
  reducers: {
    request (state, action: PayloadAction<ActionData>) {
      const { cartId } = action.payload
      const slice = getSlice(state[cartId])
      slice.isFetching = true
      state[cartId] = slice
    },

    success (state, action: PayloadAction<ActionData>) {
      const { cartId } = action.payload
      const slice = getSlice(state[cartId])
      slice.isFetching = false
      slice.isSuccess = true
      slice.isFailure = false
    },

    failure (state, action: PayloadAction<ActionData>) {
      const { cartId } = action.payload
      const slice = getSlice(state[cartId])
      slice.isFetching = false
      slice.isSuccess = false
      slice.isFailure = true
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function removeCoupon (cartId: string, callback?: Callback): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request({ cartId }))
    try {
      const response = await magentoClient.getClient().quote.couponRemove({
        cartId
      })

      const { data } = response
      const { removeCouponFromCart } = data
      const { cart } = removeCouponFromCart

      if (cart) {
        dispatch(setCart({
          cartId,
          data: cart,
          merge: true
        }))
        dispatch(success({ cartId }))
        callback?.onSuccess?.()
      } else {
        dispatch(failure({ cartId }))
        callback?.onFailure?.({
          error: new Error(`[Coupon Remove] Unexpected payload: ${JSON.stringify(response)}`),
          extraData: {
            cartId
          }
        })
      }

      return response
    } catch (e) {
      dispatch(failure({ cartId }))
      callback?.onFailure?.({
        error: new Error(`[Coupon Remove] ${e.message}`),
        extraData: {
          cartId
        }
      })
    }
  }
}
